<div class="loader" [hidden]="utilsService.loaderStart === 0">
    <div class="load-circle">
    </div>
</div>
<!-- <div style="z-index: 9999;" *ngIf="message;" class="alert alert-primary fade show custom-notification" role="alert">

  <p *ngIf="message.notification.title == 'Start Work'">{{ message.data.staff_name }} has started the work on service no {{ message.data.service_no }} at  {{ message.data.customer_name }}</p>
  <p *ngIf="message.notification.title == 'End Work'">{{ message.data.staff_name }} has completed the work on service no {{ message.data.service_no }} at  {{ message.data.customer_name }}</p>
   
</div> -->

<div class="notification-toast" *ngIf="message.length > 0">
  <div *ngFor="let message of message">
    <div *ngIf="message.notification.title == 'Start Work'" class="toast work-start fade show"  role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-body">
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        <p>{{ message.data.staff_name }} has started the work on service no {{ message.data.service_no }} at  {{ message.data.customer_name }}</p>
      </div>
    </div>

    <div *ngIf="message.notification.title == 'On Hold'" class="toast work-hold fade show"  role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-body">
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        <p>{{ message.data.staff_name }} has put your work on hold for service no {{ message.data.service_no }} at  {{ message.data.customer_name }}</p>
      </div>
    </div>

    <div *ngIf="message.notification.title == 'Resume Work'" class="toast work-resume fade show"  role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-body">
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        <p>{{ message.data.staff_name }} has resume the work on service no {{ message.data.service_no }} at  {{ message.data.customer_name }}</p>
      </div>
    </div>
  
    <div *ngIf="message.notification.title == 'End Work'" class="toast work-end fade show"  role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-body">
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        <p>{{ message.data.staff_name }} has completed the work on service no {{ message.data.service_no }} at  {{ message.data.customer_name }}</p>
      </div>
    </div>

    <div *ngIf="message.notification.title == 'Request to Admin for office'" class="toast work-end fade show"  role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-body">
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        <p>{{ message.data.staff_name }} is requesting to come to the office.</p>
      </div>
    </div>
    <div *ngIf="message.notification.title == 'Reminder'" class="toast reminder fade show"  role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-body">
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        <p>{{message.notification.body}}</p>
      </div>
    </div>
    <div *ngIf="message.notification.title == 'Non-Payment'" class="toast reminder fade show"  role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-body">
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        <p>{{message.notification.body}}</p>
      </div>
    </div>
    <div *ngIf="message.notification.title == 'Pre-Delivery'" class="toast reminder fade show"  role="alert" aria-live="assertive" aria-atomic="true">
      <div class="toast-body">
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        <p>{{message.notification.body}}</p>
      </div>
    </div>
  </div>

</div>

<router-outlet></router-outlet>
